import styled from "styled-components/macro";
export const StatusSpan = styled.span`
  margin-left: 3px;
`;
